/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconFields = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      fill={fill}
      viewBox="10 10 20 20"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 20px;
      `}
      {...props}
    >
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M11 15h18v10H11V15z"
        clipRule="evenodd"
      />
      <circle cx={20} cy={18.25} r={0.75} fill="currentColor" />
      <circle cx={20} cy={21.75} r={0.75} fill="currentColor" />
    </svg>
  ),
);
